import React from "react";
import { useTheme } from "../lib/theme";

/** Branded full-screen loading state — eneprox mark + cyan spinner. */
export default function BrandSplash({ caption = "Loading…" }) {
  const [theme] = useTheme();
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-5 bg-white">
      <img
        src={theme === "dark" ? "/brand/eneprox-logo-dark.png" : "/brand/eneprox-logo.png"}
        alt="eneprox Flow"
        style={{ height: 40, width: "auto" }}
      />
      <div
        style={{
          width: 34,
          height: 34,
          borderRadius: "50%",
          border: "4px solid var(--accent-soft)",
          borderTopColor: "var(--accent)",
          animation: "eneprox-spin 0.8s linear infinite",
        }}
      />
      <div className="label">{caption}</div>
      <style>{"@keyframes eneprox-spin{to{transform:rotate(360deg)}}"}</style>
    </div>
  );
}
